module.exports = __webpack_public_path__ + "img/cep-telefonu-sigortasi.7c420e0c.svg";